import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

interface UserTeamsState {
  userTeamIds: string[];
  
  setUserTeamIds: (teamIds: string[]) => void;
  isUserInTeam: (teamId: string) => boolean;
}

const userTeamsStore = create<UserTeamsState>()(
  subscribeWithSelector((set, get) => ({
    userTeamIds: [],
    
    setUserTeamIds: (teamIds: string[]) => set({ userTeamIds: teamIds }),
    
    isUserInTeam: (teamId: string) => {
      return get().userTeamIds.includes(teamId);
    },
  }))
);

export const useUserTeamsStore = userTeamsStore;

// Note: This store needs to be manually synced with auth user changes
// Components using this should call setUserTeamIds when user changes
// Example in a component:
// const { user } = useAuth();
// const { setUserTeamIds } = useUserTeamsStore();
// useEffect(() => {
//   if (user?.teams) {
//     setUserTeamIds(user.teams.map(t => t.id));
//   } else {
//     setUserTeamIds([]);
//   }
// }, [user, setUserTeamIds]);
